module.exports = __webpack_public_path__ + "img/vip.74470151.png";